/*
*###############################################################################
*Module Name                   : DPIframeBox.js                                #
*Purpose of the Module         : Iframe ModalUI                                #
*Description of the Module     : Common Iframe Modal Component                 #
*Original Author               :  T A C Priyashad                              #
*Date                          : Sunday, September 07nd 2021, 7:35:18 am       #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/
import React, { useState } from "react";
import { Row, Col, Card, CardBody, CardTitle, Button, Modal } from "reactstrap"
import "../../assets/scss/datatables.scss"

const DPIframeBox = (props) => {

    return (
        <div>
            <Modal
                size="xl"
                isOpen={props.isOpen}
                toggle={props.toggle}
            >
                <div className="modal-header">
                    <h5
                        className="modal-title mt-0"
                        id="myExtraLargeModalLabel"
                    >
                        {props.mainTitle}
                    </h5>
                    <button
                        onClick={props.toggle}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle className="h4">{props.SubTitle} </CardTitle>
                                    <p className="card-title-desc">
                                        {props.Details}
                                    </p>
                                    <iframe src={props.src} width={'100%'} height={'400px'}/>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                </div>
            </Modal>

        </div>
    );
}

export default DPIframeBox;